/**
 * v3.21-1670 · Frontend mirror of backend `services.funded_capability`.
 *
 * Single Funded-access rule: canonical account email must end EXACTLY
 * with `@prestigioustravelclub.org`.  No role interpretation.  No
 * specific-user grants.  No display-name matching.  The backend
 * remains the sole authoritative decision-maker; this module exists
 * only to hide the sidebar entry and short-circuit the route guard
 * for users who would fail the backend gate anyway.
 *
 * Uses the CANONICAL account email carried in the auth payload
 * (`/auth/me`, `/auth/login`), not any client-editable field.
 */
const CORPORATE_EMAIL_DOMAIN = 'prestigioustravelclub.org';

export function hasCorporateEmail(user) {
  if (!user) return false;
  const raw = user.email;
  if (typeof raw !== 'string') return false;
  const email = raw.trim().toLowerCase();
  if (!email) return false;
  // Exactly one `@`, non-empty local part, exact-literal domain.
  const parts = email.split('@');
  if (parts.length !== 2) return false;
  const [local, domain] = parts;
  if (!local) return false;
  return domain === CORPORATE_EMAIL_DOMAIN;
}

export function canAccessFunded(user) {
  return hasCorporateEmail(user);
}

export default canAccessFunded;
